(function () {
    'use strict';

    a3_cabin_reports.factory('TraineeCoursesDetailsFactory', TraineeCoursesDetailsFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name TraineeCoursesDetailsFactory
     * @description 
     * Get, Set and Submit Trainee Courses Details.
     * @ngInject
     */
    function TraineeCoursesDetailsFactory(localStorageMD5Service, $http, apiUrl, GenericService, $timeout) {

        var objTypeGround ='traineeCourses';
        var objTypeFlight ='traineeFlightCourses';
		var objCallbackGround = TraineeCourses;
        var objCallbackFlights = TraineeFlightCourses;

        window.addEventListener('online', function (e) { $timeout(checkConnectionStatus()); });

        var response = { success: false, 
            message: '', 
            Results: []
        };

        var service = {
            setTraineeCoursesToStorage: setTraineeCoursesToStorage,
            getTraineeGroundCourses: getTraineeGroundCourses,
            getTraineeCourses: getTraineeCourses,
            getTraineeCourse: getTraineeCourse,
            setTraineeFlightCoursesToStorage: setTraineeFlightCoursesToStorage,
            getTraineeFlightCourses: getTraineeFlightCourses,
            getFlightCourses: getFlightCourses
        };

        function TraineeCourses() {
            this.DutyDate = null; 
            this.Status = null; 
            this.GroundDutyId = null;
        }

        function checkConnectionStatus() {
                response.success = false;
                response.message = "Please check the internet connection!";

        }

           /**
         * Set all the trainee courses
         * @memberof TraineeCoursesDetailsFactory
         * @param {array} objects A list of trainee courses.
         */
		function setTraineeCoursesToStorage(data) {
            GenericService.saveAll(data, objTypeGround, objCallbackGround);	
		}

        function getTraineeGroundCourses(dutyId) {
            var results = [];
            var listOfValues = localStorageMD5Service.get(objTypeGround);
            if(listOfValues){
                var traineeCoursesPerDuty = listOfValues.filter(function (item) {
                    return item.GroundDutyId == dutyId;
                });
                results = traineeCoursesPerDuty.map(function (item) {
                    return item;
                });
            }
			return (results);
        }

        function getTraineeCourses() {
			return GenericService.list(objTypeGround,objCallbackGround);
		}

        function getFlightCourses() {
            return GenericService.list(objTypeFlight,objCallbackFlights);
        }

        function TraineeFlightCourses(){}

        function getTraineeCourse(traineeCourseId, callback) {
          return $http.get(apiUrl + '/Training/GetTraineeCourse?traineeCourseId=' + traineeCourseId, { 'Content-Type': 'application/json' })
            .then(res => updateTraineeCourseCallBack(res))
            .catch(res => traineeCourseFailedCallBack(res));        
        } 

        function updateTraineeCourseCallBack(res) {
            response.success = res.data.success;
            if (res.data.success) {    
                response.Results = res.data;
            }
            else {
                response.message = res.data.errorMessage
            }

            return response;
        }

         /**
        * The callback function upon failure on submit
        * @returns {object} response
        */
         function traineeCourseFailedCallBack(res) {
            if(!window.navigator.onLine){
                checkConnectionStatus();
            }
           else{
            response.success = false;
            response.message = "Oops! Something went wrong"
   
            //TODO::Check status=500 error: returns res = {data: {…}, status: 500, config: {…}, statusText: "Internal Server Error", headers: ƒ}
            // res.data.data is null
            if(res.data.data && res.data.data.Results){
                response.Results = res.data.data.Results;
            }else{
                //log results
                console.log(res);
            }
           }
          
            return response;
        }
        
        function setTraineeFlightCoursesToStorage(data) {
            GenericService.saveAll(data, objTypeFlight, objCallbackFlights);
		}
        
        function getTraineeFlightCourses(flightId) {
            var results = [];
            var listOfValues = localStorageMD5Service.get(objTypeFlight);
            if(listOfValues){
                var traineeCoursesPerDuty = listOfValues.filter(function (item) {
                    return item.FlightId == flightId;
                });
                results = traineeCoursesPerDuty.map(function (item) {
                    return item;
                });
            }
			return (results);
        }
            return service;
        }

})();
